import React from "react";
import DatePicker from "react-datepicker";
import TimePicker from "rc-time-picker";
import Compensation from "../../../images/Compensation.svg";
import ToggleComponent from "../../../containers/Common/ToggleComponent";
import "react-datepicker/dist/react-datepicker.css";
import {
  format, PHONE_PLACEHOLDER, MODAL_SIZE,
} from "../../../App.config";
import "rc-time-picker/assets/index.css";
import backArrow from "../../../images/back-arrow.svg";
import CustomDatePicker from "../../../containers/Common/CustomDatePicker";
import moment from "moment";
import ManagerDetailModal from "../../Std/ManagerDetailModal.jsx";
import DropdownComponent from "../../../containers/Dropdown";
import add from "../../../images/add.svg";
import UploadSvg from "../../../images/upload.svg";
import AttachmentTable from "../AttachmentTable";
import DisplayEmployeeBlock from "../DisplayEmployeeBlock";

const ReturnToWorkInformation = ({
  onSubmit,
  previousStep,
  state,
  props,
  handleChanges,
  handlePhoneNumber,
  onTimeChange,
  onDateChange,
  handleQuestionChange,
  onDropDownChange,
  download,
  removeFile,
  attachmentRef,
  addDescription,
  handleFileUpload,
}) => {
  const onAddManager = () => {
    props.openSetModalAction(
      <ManagerDetailModal
        {...props}
      // jobID={state.jobTitle.value}
      // locationID={state.location.value}

      />,
      MODAL_SIZE.MODAL_SM
    );
  };

  return (
    <>
      <div className="Dashboard-Content">
        <div className="Inner-cell">
          <div className="Panel-cell">
            <div className="Panel-header">
              <img
                tabIndex="-1"
                className="btn btn-back"
                onClick={previousStep}
                src={backArrow}
                alt="back-arrow"
              />
              <div className="p-img">
                <img src={Compensation} alt="" />
              </div>
              <h2>
                <span>
                  {props.context.t("AIR-return-to-work-info.form.heading.text")}
                </span>
              </h2>
            </div>
            <div className="panel-content">
              <DisplayEmployeeBlock context={props.context} state={state} />
              <div className="Custom-form">
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                    <div className="form-group Ctm-rdo">
                      <label htmlFor="">
                        {props.context.t(
                          "AIR-return-to-work-info.form.label.text.Que1"
                        )}
                      </label>
                      <ToggleComponent
                        name="loseTimeFromWork"
                        isActive={state.loseTimeFromWork.value}
                        negativeValueTobeCompare="No"
                        positiveValueTobeCompare="Yes"
                        positiveValueTobeDisplay={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.Toggle.Yes.Common"
                        )}
                        negativeValueTobeDisplay={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.Toggle.No.Common"
                        )}
                        handleChanges={handleQuestionChange}
                      />
                    </div>
                  </div>
                  {state.loseTimeFromWork.value === "Yes" ? (
                    <div className="row">
                      <div className="col-12 col-sm-12 col-md-12 col-lg-5 Date-feild">
                        <div className="form-group">
                          <label htmlFor="">
                            {props.context.t(
                              "AIR-return-to-work-info.form.label.text.LastDayWorked"
                            )}
                            <span size="5" className="error-star">
                              *
                            </span>
                            {props.context.t("AIR-Employer-Information.form.common.DateFormat")}
                          </label>
                          <CustomDatePicker
                            id="lastDayWorkedDate"
                            selected={state.lastDayWorkedDate.value && state.lastDayWorkedDate.value}
                            onChange={(e) => {
                              onDateChange(e, "lastDayWorkedDate");
                            }}
                            maxDate={moment().toDate()}
                            ref={state.lastDayWorkedDate.ref}
                            className="form-control"
                            placeholderText={props.context.t(
                              "AIR-Employer-Information.form.common.DateFormat"
                            )}
                          />
                          {state.lastDayWorkedDate?.error && (
                            <span className="error">
                              {state.lastDayWorkedDate.error}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                        <div className="form-group">
                          <label htmlFor="">
                            {props.context.t(
                              "AIR-Accident-Information.form.label.text.Time"
                            )}
                            <span size="5" className="error-star">
                              *
                            </span>
                          </label>
                          <input
                            type="text"
                            placeholder="00:00"
                            name="lastDayWorkTime"
                            value={state.lastDayWorkTime.value}
                            ref={state.lastDayWorkTime.ref}
                            onChange={handleChanges}
                            className="form-control"
                          />
                          {state.lastDayWorkTime?.error && (
                            <span className="error">
                              {state.lastDayWorkTime.error}
                            </span>
                          )}
                          <small>
                            <p>{props.context.t("AIR-Accident-Information.form.label.text.12HourFormat")}</p>
                          </small>
                        </div>
                      </div>
                      <div className="col-4 col-sm-12 col-md-4 col-lg-3">
                        <div className="Ctm-rdo">
                          <label htmlFor="">

                          </label>
                          <div className="Radio-box" data-toggle="buttons">
                            <div className="check-col">
                              <input
                                type="radio"
                                name="lastDayWorkTimeRadio"
                                id="lastDayWorkTimeRadio-AM"
                                autoComplete="off"
                                onChange={handleChanges}
                                value="AM"
                                checked={
                                  state.lastDayWorkTimeRadio.value === "AM"
                                }
                              />
                              <label htmlFor="lastDayWorkTimeRadio-AM">

                                AM
                              </label>
                            </div>
                            <div className="check-col">
                              <input
                                type="radio"
                                name="lastDayWorkTimeRadio"
                                id="lastDayWorkTimeRadio-PM"
                                autoComplete="off"
                                onChange={handleChanges}
                                value="PM"
                                checked={
                                  state.lastDayWorkTimeRadio.value === "PM"
                                }
                              />
                              <label htmlFor="lastDayWorkTimeRadio-PM">

                                PM
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : null}

                </div>
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                    <div className="form-group Ctm-rdo">
                      <label htmlFor="">
                        {props.context.t(
                          "AIR-return-to-work-info.form.label.text.Que2"
                        )}
                      </label>
                      <ToggleComponent
                        name="hasRTW"
                        isActive={state.hasRTW.value}
                        negativeValueTobeCompare="No"
                        positiveValueTobeCompare="Yes"
                        positiveValueTobeDisplay={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.Toggle.Yes.Common"
                        )}
                        negativeValueTobeDisplay={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.Toggle.No.Common"
                        )}
                        handleChanges={handleQuestionChange}
                      />
                    </div>
                  </div>
                </div>
                {state.hasRTW.value === "Yes" &&
                  <div className="row">
                    <div className="col-12 col-sm-12 col-md-12 col-lg-8">
                      <div className="form-group Ctm-rdo">
                        <label htmlFor="">
                          {props.context.t(
                            "AIR-return-to-work-info.form.label.text.TypeofWork"
                          )}
                          <span size="5" className="error-star">
                            *
                          </span>
                        </label>
                        <div className="Radio-box" data-toggle="buttons">
                          <div className="check-col">
                            <input
                              type="radio"
                              name="typeRTW"
                              id="Regular-Work"
                              autoComplete="off"
                              onChange={handleChanges}
                              value="Regular Work"
                              checked={state.typeRTW.value === "Regular Work"}
                            />
                            <label htmlFor="Regular-Work">
                              {props.context.t(
                                "AIR-return-to-work-info.form.label.text.Regular-Work"
                              )}
                            </label>
                          </div>
                          <div className="check-col">
                            <input
                              type="radio"
                              name="typeRTW"
                              id="modified"
                              autoComplete="off"
                              onChange={handleChanges}
                              value="Modified Work"
                              checked={state.typeRTW.value === "Modified Work"}
                            />
                            <label htmlFor="modified">
                              {props.context.t(
                                "AIR-return-to-work-info.form.label.text.Modified"
                              )}
                            </label>
                          </div>
                        </div>
                      </div>
                      {state.typeRTW.value === "Other" ? (
                        <div>
                          <div className="form-group">
                            <input
                              type="text"
                              placeholder={props.context.t(
                                "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                              )}
                              className="form-control"
                              name="typeRTWExtra"
                              value={state.typeRTWExtra.value}
                              ref={state.typeRTWExtra.ref}
                              onChange={handleChanges}
                            />
                            {state.typeRTWExtra?.error && (
                              <span className="error">
                                {state.typeRTWExtra.error}
                              </span>
                            )}
                          </div>
                        </div>
                      ) : null}
                    </div>

                    <div className="row">
                      <div className="col-12 col-sm-12 col-md-12 col-lg-6  Date-feild">
                        <div className="form-group">
                          <label htmlFor="">
                            {props.context.t(
                              "AIR-return-to-work-info.form.label.text.DateReturnedWork"
                            )}
                            <span size="5" className="error-star">
                              *
                            </span>
                            {props.context.t("AIR-Employer-Information.form.common.DateFormat")}
                          </label>
                          <CustomDatePicker
                            id="rtwDate"
                            selected={state.rtwDate.value && state.rtwDate.value}
                            onChange={(e) => {
                              onDateChange(e, "rtwDate");
                            }}
                            maxDate={moment().toDate()}
                            ref={state.rtwDate.ref}
                            className="form-control"
                            placeholderText={props.context.t(
                              "AIR-Employer-Information.form.common.DateFormat"
                            )}
                          />
                          {state.rtwDate?.error && (
                            <span className="error">{state.rtwDate.error}</span>
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                        <div className="form-group">
                          <label htmlFor="">
                            {props.context.t(
                              "AIR-Accident-Information.form.label.text.Time"
                            )}
                            <span size="5" className="error-star">
                              *
                            </span>
                            {/* (MM/DD/YY) */}
                          </label>

                          <input
                            type="text"
                            // placeholder={props.context.t(
                            //   "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                            // )}
                            placeholder="00:00"
                            name="rtwTime"
                            value={state.rtwTime.value}
                            ref={state.rtwTime.ref}
                            onChange={handleChanges}
                            className="form-control"
                          />
                          {state.rtwTime?.error && (
                            <span className="error">
                              {state.rtwTime.error}
                            </span>
                          )}
                          <small>
                            <p>{props.context.t("AIR-Accident-Information.form.label.text.12HourFormat")}</p>
                          </small>

                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-12 col-lg-2">
                        <div className="form-group">
                          <div className="Radio-box" data-toggle="buttons">
                            <div className="check-col">
                              <input
                                type="radio"
                                name="rtwTimeRadio"
                                id="rtwTimeRadio-AM"
                                autoComplete="off"
                                onChange={handleChanges}
                                value="AM"
                                checked={
                                  state.rtwTimeRadio.value === "AM"
                                }
                              />
                              <label htmlFor="rtwTimeRadio-AM">

                                AM
                              </label>
                            </div>
                            <div className="check-col">
                              <input
                                type="radio"
                                name="rtwTimeRadio"
                                id="rtwTimeRadio-PM"
                                autoComplete="off"
                                onChange={handleChanges}
                                value="PM"
                                checked={
                                  state.rtwTimeRadio.value === "PM"
                                }
                              />
                              <label htmlFor="rtwTimeRadio-PM">

                                PM
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>


                    {/* <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                      <div className="form-group Ctm-rdo">
                        <label htmlFor="">
                          {props.context.t(
                            "AIR-return-to-work-info.form.label.text.TypeofWork"
                          )}
                          <span size="5" className="error-star">
                            *
                          </span>
                        </label>
                        <div className="Radio-box" data-toggle="buttons">
                          <div className="check-col">
                            <input
                              type="radio"
                              name="typeRTW"
                              id="Regular-Work"
                              autoComplete="off"
                              onChange={handleChanges}
                              value="Regular Work"
                              checked={state.typeRTW.value === "Regular Work"}
                            />
                            <label htmlFor="Regular-Work">
                              {props.context.t(
                                "AIR-return-to-work-info.form.label.text.Regular-Work"
                              )}
                            </label>
                          </div>
                          <div className="check-col">
                            <input
                              type="radio"
                              name="typeRTW"
                              id="modified"
                              autoComplete="off"
                              onChange={handleChanges}
                              value="Modified Work"
                              checked={state.typeRTW.value === "Modified Work"}
                            />
                            <label htmlFor="modified">
                              {props.context.t(
                                "AIR-return-to-work-info.form.label.text.Modified"
                              )}
                            </label>
                          </div>
                        </div>
                      </div>
                      {state.typeRTW.value === "Other" ? (
                        <div>
                          <div className="form-group">
                            <input
                              type="text"
                              placeholder={props.context.t(
                                "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                              )}
                              className="form-control"
                              name="typeRTWExtra"
                              value={state.typeRTWExtra.value}
                              ref={state.typeRTWExtra.ref}
                              onChange={handleChanges}
                            />
                            {state.typeRTWExtra?.error && (
                              <span className="error">
                                {state.typeRTWExtra.error}
                              </span>
                            )}
                          </div>
                        </div>
                      ) : null}
                    </div> */}
                  </div>
                }
                <h2 className="Sub-Heading">
                  <span>
                    {props.context.t(
                      "AIR-return-to-work-info.form.label.text.title1"
                    )}
                  </span>
                </h2>
                <div className="row">
                  <div>
                    {/* {state.alteredDuties.value === "Yes" ? (
                        <div>
                          <div className="form-group">
                            <input
                              type="text"
                              placeholder={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                        )}
                              className="form-control"
                              placeholder={props.context.t(
                                "STD-Employer-Statement.form.dropdown.PlaceHolder.Common.IfOtherdescribe"
                              )}
                              name="isAlteredDutiesYes"
                              value={state.isAlteredDutiesYes.value}
                              onChange={handleChanges}
                            />
                          </div>
                        </div>
                      ) : null} */}
                  </div>
                  {/* <div className="col-12 col-sm-12 col-md-12 col-lg-12"> */}
                  {/* <div className="form-group Ctm-rdo">
                      <label htmlFor="">
                        {props.context.t(
                          "AIR-return-to-work-info.form.label.text.Que3"
                        )}
                      </label>
                      <ToggleComponent
                        name="rtwQuestion1"
                        isActive={state.rtwQuestion1.value}
                        negativeValueTobeCompare="No"
                        positiveValueTobeCompare="Yes"
                        positiveValueTobeDisplay={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.Toggle.Yes.Common"
                        )}
                        negativeValueTobeDisplay={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.Toggle.No.Common"
                        )}
                        handleChanges={handleChanges}
                      />
                    </div> */}

                  {/* {state.alteredDuties.value === "Yes" ? (
                        <div>
                          <div className="form-group">
                            <input
                              type="text"
                              placeholder={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                        )}
                              className="form-control"
                              placeholder={props.context.t(
                                "STD-Employer-Statement.form.dropdown.PlaceHolder.Common.IfOtherdescribe"
                              )}
                              name="isAlteredDutiesYes"
                              value={state.isAlteredDutiesYes.value}
                              onChange={handleChanges}
                            />
                          </div>
                        </div>
                      ) : null} */}

                  {/* </div> */}
                  <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                    <div className="form-group Ctm-rdo">
                      <label htmlFor="">
                        {props.context.t(
                          "AIR-return-to-work-info.form.label.text.Que4"
                        )}
                      </label>
                      <ToggleComponent
                        name="rtwQuestion2"
                        isActive={state.rtwQuestion2.value}
                        negativeValueTobeCompare="No"
                        positiveValueTobeCompare="Yes"
                        positiveValueTobeDisplay={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.Toggle.Yes.Common"
                        )}
                        negativeValueTobeDisplay={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.Toggle.No.Common"
                        )}
                        handleChanges={handleChanges}
                      />
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                    <div className="form-group Ctm-rdo">
                      <label htmlFor="">
                        {props.context.t(
                          "AIR-return-to-work-info.form.label.text.WorkOffered"
                        )}
                      </label>
                      <ToggleComponent
                        name="rtwQuestion4"
                        isActive={state.rtwQuestion4.value}
                        negativeValueTobeCompare="No"
                        positiveValueTobeCompare="Yes"
                        positiveValueTobeDisplay={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.Toggle.Yes.Common"
                        )}
                        negativeValueTobeDisplay={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.Toggle.No.Common"
                        )}
                        handleChanges={handleChanges}
                      />
                      {/* <div className="Radio-box" data-toggle="buttons">
                        <div className="check-col">
                          <input
                            type="radio"
                            name="rtwQuestion4"
                            id="rtw-yes"
                            autoComplete="off"
                            onChange={handleChanges}
                            value="Yes"
                            checked={state.rtwQuestion4.value === "Yes"}
                          />
                          <label htmlFor="rtw-yes">
                            {props.context.t(
                              "AIR-return-to-work-info.form.label.text.WorkOffered.Yes"
                            )}
                          </label>
                        </div>
                        <div className="check-col">
                          <input
                            type="radio"
                            name="rtwQuestion4"
                            id="rtw-No"
                            autoComplete="off"
                            onChange={handleChanges}
                            value="No"
                            checked={state.rtwQuestion4.value === "No"}
                          />
                          <label htmlFor="rtw-No">
                            {props.context.t(
                              "AIR-return-to-work-info.form.label.text.WorkOffered.No"
                            )}
                          </label>
                        </div>
                      </div> */}
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                    <div className="form-group Ctm-rdo">
                      <label htmlFor="">
                        {props.context.t(
                          "AIR-return-to-work-info.form.label.text.Que5"
                        )}
                      </label>
                      <ToggleComponent
                        name="rtwQuestion3"
                        isActive={state.rtwQuestion3.value}
                        negativeValueTobeCompare="No"
                        positiveValueTobeCompare="Yes"
                        positiveValueTobeDisplay={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.Toggle.Yes.Common"
                        )}
                        negativeValueTobeDisplay={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.Toggle.No.Common"
                        )}
                        handleChanges={handleQuestionChange}
                      />
                    </div>
                    <div>
                      {state.rtwQuestion3.value === "Yes" ? (
                        <div>
                          <div className="form-group">
                            <input
                              type="text"
                              placeholder={props.context.t(
                                "AIR-return-to-work-info.form.label.text.Que5Placehlder"
                              )}
                              className="form-control"
                              name="rtwQuestion3Extra"
                              value={state.rtwQuestion3Extra.value}
                              ref={state.rtwQuestion3Extra.ref}
                              onChange={handleChanges}
                            />
                          </div>
                          {state.rtwQuestion3Extra?.error && (
                            <span className="error">
                              {state.rtwQuestion3Extra.error}
                            </span>
                          )}
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
                {/* <h2 className="Sub-Heading">
                  <span>
                    {props.context.t(
                      "AIR-return-to-work-info.form.label.text.title2"
                    )}
                  </span>
                </h2> */}
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                    <div className="form-group Ctm-rdo">
                      <label htmlFor="">
                        {props.context.t(
                          "AIR-return-to-work-info.form.label.text.WhoIsResponsible"
                        )}
                      </label>

                      <div className="Radio-box" data-toggle="buttons">
                        <div className="check-col">
                          <input
                            type="radio"
                            name="whoIsResponsible"
                            id="whoIsResponsible-Myself"
                            autoComplete="off"
                            onChange={handleQuestionChange}
                            value="Myself"
                            checked={state.whoIsResponsible.value === "Myself"}
                          />
                          <label htmlFor="whoIsResponsible-Myself">
                            {props.context.t(
                              "AIR-return-to-work-info.form.label.text.WhoIsResponsible.Myself"
                            )}
                          </label>
                        </div>
                        <div className="check-col">
                          <input
                            type="radio"
                            name="whoIsResponsible"
                            id="whoIsResponsible-Manager"
                            autoComplete="off"
                            onChange={handleQuestionChange}
                            value="Manager"
                            checked={state.whoIsResponsible.value === "Manager"}
                          />
                          <label htmlFor="whoIsResponsible-Manager">
                            {props.context.t(
                              "AIR-return-to-work-info.form.label.text.WhoIsResponsible.Manager"
                            )}
                          </label>
                        </div>
                        <div className="check-col">
                          <input
                            type="radio"
                            name="whoIsResponsible"
                            id="whoIsResponsible-Other"
                            autoComplete="off"
                            onChange={handleQuestionChange}
                            value="Other"
                            checked={state.whoIsResponsible.value === "Other"}
                          />
                          <label htmlFor="whoIsResponsible-Other">
                            {props.context.t(
                              "AIR-return-to-work-info.form.label.text.WhoIsResponsible.Other"
                            )}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  {(state.whoIsResponsible.value === "Other" || state.showManager1) &&
                    <div className="col-12 col-sm-12 col-md-12 col-lg-5">
                      <div className="form-group">
                        <label htmlFor="">
                          {props.context.t(
                            "AIR-return-to-work-info.form.label.text.WhoIsResponsible.Manager"
                          )}
                        </label>
                        <div className="Custom-select">
                          {props.supervisorList && (
                            <DropdownComponent
                              name="responsibleManager"
                              id="responsibleManager"
                              options={props.supervisorList}
                              isMultiSelect={false}
                              option_key="supervisorID_PK"
                              option_display="fullNameWithEmail"//"primaryName"
                              onChange={onDropDownChange}
                              values={state.responsibleManager.value}
                              simplePlaceholder="STD-Employer-Statement.form.dropdown.PlaceHolder.Common.SelectOptions"
                              selectAllText="Select All Options"
                              isSearchOption={true}
                              searchPlaceholder="STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                              ref={state.responsibleManager.ref}
                            />
                          )}
                          {state.responsibleManager?.error && (
                            <span className="error">
                              {state.responsibleManager.error}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  }
                  {/* {state.whoIsResponsible.value === "Manager" &&
                    <div className="col-1 col-sm-1 col-md-1 col-lg-1">
                      <div className="form-group margin-top-30">
                        <a onClick={onAddManager} className="btn">
                          <img src={add} />
                        </a>
                      </div>
                    </div>
                  } */}
                </div>
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-6">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "AIR-return-to-work-info.form.label.text.Name"
                        )}
                        {/* <span size="5" className="error-star">
                          *
                        </span> */}
                      </label>
                      <input
                        type="text"
                        placeholder={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                        )}
                        readOnly={!state.responsibleRTWName.isEditable}
                        name="responsibleRTWName"
                        value={state.responsibleRTWName.value}
                        onChange={handleChanges}
                        ref={state.responsibleRTWName.ref}
                        className="form-control"
                      />
                      {state.responsibleRTWName?.error && (
                        <span className="error">
                          {state.responsibleRTWName.error}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-12 col-lg-6">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "AIR-return-to-work-info.form.label.text.Telephone"
                        )}
                        {/* <span size="5" className="error-star">
                          *
                        </span> */}
                      </label>
                      <input
                        type="text"
                        placeholder={PHONE_PLACEHOLDER}
                        name="responsibleRTWTelephone"
                        value={state.responsibleRTWTelephone.value}
                        onChange={handlePhoneNumber}
                        readOnly={!state.responsibleRTWTelephone.isEditable}
                        ref={state.responsibleRTWTelephone.ref}
                        maxLength="14"
                        className="form-control"
                      />
                      {state.responsibleRTWTelephone?.error && (
                        <span className="error">
                          {state.responsibleRTWTelephone.error}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                    <div className="form-group Ctm-rdo">
                      <label htmlFor="">
                        {props.context.t(
                          "AIR-return-to-work-info.form.label.text.Que6"
                        )}
                      </label>
                      <ToggleComponent
                        name="rtwQuestion5"
                        isActive={state.rtwQuestion5.value}
                        negativeValueTobeCompare="No"
                        positiveValueTobeCompare="Yes"
                        positiveValueTobeDisplay={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.Toggle.Yes.Common"
                        )}
                        negativeValueTobeDisplay={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.Toggle.No.Common"
                        )}
                        handleChanges={handleChanges}
                      />
                    </div>
                    <div>
                      {state.rtwQuestion5.value === "Yes" ? (
                        <div className="row">
                          <div className="col-md-6">
                            <div className="form-group">
                              <label>Date</label>
                              <CustomDatePicker
                                id="rtwQuestion5Extra"
                                selected={state.rtwQuestion5Extra.value && state.rtwQuestion5Extra.value}
                                onChange={(e) => {
                                  onDateChange(e, "rtwQuestion5Extra");
                                }}
                                maxDate={moment().toDate()}
                                ref={state.rtwQuestion5Extra.ref}
                                className="form-control"
                                placeholderText={props.context.t(
                                  "AIR-Employer-Information.form.common.DateFormat"
                                )}
                              />
                            </div>
                          </div>
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-6">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "AIR-return-to-work-info.form.label.text.Que7"
                        )}
                      </label>
                      <input
                        type="text"
                        placeholder={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                        )}
                        name="rtwQuestion6"
                        value={state.rtwQuestion6.value}
                        onChange={handleChanges}
                        ref={state.rtwQuestion6.ref}
                        className="form-control"
                      />
                      {/* <ToggleComponent
                        name="rtwQuestion6"
                        isActive={state.rtwQuestion6.value}
                        negativeValueTobeCompare="No"
                        positiveValueTobeCompare="Yes"
                        positiveValueTobeDisplay={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.Toggle.Yes.Common"
                        )}
                        negativeValueTobeDisplay={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.Toggle.No.Common"
                        )}
                        handleChanges={handleChanges}
                      /> */}
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-12 col-lg-6">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "AIR-return-to-work-info.form.label.text.Que8"
                        )}
                      </label>
                      <input
                        type="text"
                        placeholder={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                        )}
                        name="rtwQuestion7"
                        value={state.rtwQuestion7.value}
                        onChange={handleChanges}
                        ref={state.rtwQuestion7.ref}
                        className="form-control"
                      />
                      {/* <ToggleComponent
                        name="rtwQuestion7"
                        isActive={state.rtwQuestion7.value}
                        negativeValueTobeCompare="No"
                        positiveValueTobeCompare="Yes"
                        positiveValueTobeDisplay={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.Toggle.Yes.Common"
                        )}
                        negativeValueTobeDisplay={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.Toggle.No.Common"
                        )}
                        handleChanges={handleChanges}
                      /> */}
                    </div>
                  </div>

                </div>

                {/* Additional Information */}
                <h2 className="Sub-Heading">
                  <span>
                    {props.context.t(
                      "STD-Employer-Statement.form.subheading8.text"
                    )}
                  </span>
                </h2>
                <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                  <div className="form-group">
                    <textarea
                      type="text"
                      className="form-control"
                      placeholder=""
                      name="additionalNotesAdd"
                      value={state.additionalNotesAdd.value}
                      onChange={handleChanges}
                    />
                    {state.additionalNotesAdd?.error && (
                      <span className="error">
                        {state.additionalNotesAdd.error}
                      </span>
                    )}
                  </div>
                </div>


                <h2 className="Sub-Heading">
                  <span>
                    {props.context.t(
                      "STD-Employer-Statement.form.subheading6.text"
                    )}
                  </span>
                </h2>
                <div className="row">
                  <div className="col-xl-5 col-md-6 col-12">
                    <div className="form-group">
                      {/* <label htmlFor="">Attachments [Upload Attachments]</label> */}
                      <div className="upload-btn-wrapper form-control">
                        <button tabIndex="-1" className="upload-btn">
                          <img tabIndex="-1" src={UploadSvg} alt="" />
                          {props.context.t(
                            "STD-Employer-Statement.form.Employer-Details.label.text.Upload"
                          )}

                        </button>
                        <input
                          onChange={handleFileUpload}
                          type="file"
                          tabIndex="-1"
                          name="attachment"
                          ref={attachmentRef}
                        />
                      </div>
                      <small>
                        {props.context.t(
                          "AIR-Employer-Statement.form.Employer-Details.label.text.File-Format"
                        )}
                      </small>
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  {Array.isArray(props.attachment) &&
                    props.attachment.length ? (
                    <AttachmentTable
                      attachment={props.attachment}
                      download={download}
                      removeFile={removeFile}
                      addDescription={addDescription}
                    />
                  ) : null}
                </div>

                <div className="Check-box">
                  <div>
                    <input
                      className="styled-checkbox"
                      type="checkbox"
                      id="declaration"
                      name="declaration"
                      onChange={handleChanges}
                      checked={state.declaration.value}
                      ref={state.declaration.ref}
                    />
                    <label htmlFor="declaration">
                      <span>
                        {props.context.t(
                          "AIR-Accident-Details.form.label.text.Declaration"
                        )}
                      </span>
                    </label>
                    <span className="error">{state.declaration.error}</span>
                  </div>
                </div>

                <div className="panel-footer text-right margn-50">
                  <a
                    tabIndex="0"
                    onClick={() => onSubmit(true, false)}
                    className={
                      state.declaration.value
                        ? "btn btn-primary"
                        : "btn btn-primary disabled"
                    }
                  >
                    {props.context.t(
                      "AIR-Accident-Details.form.label.text.Save.title"
                    )}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default ReturnToWorkInformation;
